import NavigationPath from './NavigationPath';

export default NavigationPath;
